import { useRequest } from 'ahooks'
import { Collapse, CollapsePanelProps, List, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { RiskBar } from '@/components'
import { routes } from '@/router'
import { Portfolio } from '@/schemas'
import { ga, traceEvent } from '@/utils/ga'

import { PlanDate } from './plan-date.component'
import { Switch } from './switch.component'

const { Text } = Typography

export const MyPortfolios: React.FC<CollapsePanelProps> = (props) => {
  const [searchType, setSearchType] = React.useState(1)
  const { t } = useTranslation()
  const { data } = useRequest<Portfolio[]>(
    {
      url: '/api/portfolio/getMyPortfolios',
      params: {
        searchType,
      },
    },
    {
      refreshDeps: [searchType],
    }
  )

  const options = [
    { label: t('owner'), value: 1, name: '负责' },
    { label: t('join in'), value: 2, name: '参与' },
  ]

  const onChange = (searchType: number) => {
    setSearchType(searchType)
  }

  const header = (
    <>
      <span>{props.header}</span>
      <Switch options={options} value={searchType} onChange={onChange} />
    </>
  )

  return (
    <>
      <Collapse.Panel {...props} header={header}>
        <List
          className='max-h-600px overflow-y-auto'
          itemLayout='horizontal'
          loading={!data}
          size='small'
          bordered
          locale={{ emptyText: <div className='text-left'>我的组合在此展示</div> }}
          dataSource={data || []}
          renderItem={(p) => (
            <List.Item className='space-x-24px'>
              <Text className='flex-grow flex'>
                <RiskBar className='mr-20px' risk={p.risk} />
                <Link
                  to={routes.portfolio.page(p.selfId)}
                  onClick={() => {
                    ga('event', traceEvent.personalPage.events.click_check_detail, {
                      event_category:
                        searchType === 1
                          ? traceEvent.personalPage.event_categories.ef_pmo_home_my_portfolios_owner
                          : traceEvent.personalPage.event_categories.ef_pmo_home_my_portfolios_member,
                      action: traceEvent.personalPage.action,
                      event_label: p.name,
                      target: traceEvent.personalPage.targets.ef_pmo_portfolio_detail,
                    })

                    window.sessionStorage.setItem('entry', traceEvent.detailPage.event_categories.ef_pmo_home)
                  }}
                >
                  {p.name}
                </Link>
              </Text>

              <PlanDate date={p.endDate} tooltip={t('end')} />
            </List.Item>
          )}
        />
      </Collapse.Panel>
    </>
  )
}
